import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonClose.propTypes = {
  type: PropTypes.string.isRequired,
  constructorFunctions: PropTypes.object.isRequired,
  withinDropdown: PropTypes.bool
}

export default function ButtonClose({
  type,
  constructorFunctions,

  withinDropdown = false
}) {
  return (
    <Button
      icon='close-circle'
      className={withinDropdown ? 'btn-within-dropdown' : ''}
      type='danger'
      onClick={e => {
        e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown
        get(constructorFunctions, 'askClosePermit')(type)
      }}
    >
      {type === 'firePermit'
        ? I18n.t('pages.permits.actions.controlAndClose')
        : I18n.t('pages.permits.actions.close')}
    </Button>
  )
}
